function Estadistica(){
  return (
    <div>
      <h1>Estadistica</h1>
    </div>
  )
}

export default Estadistica;